import React from 'react';
import { thumbUrl } from '../utils/image';
import { Car } from '../types/car';
import { formatARS, formatKm } from '../utils/format';
interface CarSummaryProps {
  car: Car;
}
export function CarSummary({
  car
}: CarSummaryProps) {
  return <div className="flex items-center gap-4 rounded-xl border border-line bg-ink p-3" data-id="element-44" data-mp="3kzr3lzhdkd7t">
      <img src={thumbUrl(car.image, 240)} alt="" className="h-16 w-24 shrink-0 rounded-lg object-cover" data-id="element-45" data-mp="3g1xyl9rt5p94" />
      <div className="min-w-0" data-id="element-46" data-mp="2sc3ov12scgt3">
        <p className="truncate font-display text-lg font-semibold text-white" data-id="element-47" data-mp="2ncs65miuz18v">
          {car.brand} {car.model} <span className="font-medium text-muted" data-id="element-48" data-mp="329rjzs4azqbs">{car.version}</span>
        </p>
        <p className="text-xs text-muted" data-id="element-49" data-mp="327ol0il6amux">
          {car.year} · {formatKm(car.km)} · Contado <span className="font-semibold text-neon" data-id="element-50" data-mp="2xd153848j0ry">{formatARS(car.cashPrice)}</span>
        </p>
      </div>
    </div>;
}